import React from 'react'
import PropTypes from 'prop-types'
import { Box } from '@material-ui/core'

export default function TabPanel(props) {
  const {children, value, index, height="100%", ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      style={{height: height}}
    >
      {value === index && (
        <Box style={{height: height, overflow:"auto"}} {...other}>
          {children}
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};